import { chakra } from "@chakra-ui/react";

export const CustomCard = chakra("div", {
  baseStyle: { bg: "white",  py: "2", fontFamily: 'Poppins', }, 
});
